// stores/patientsCombo.js - فقط برای استفاده در کامپوننت select
import { createGenericStore } from './genericStore';

export const usePatientsComboStore = createGenericStore(
  'patientsCombo', // نام متفاوت برای store
  '/Patient/GetAllAsync',
  {
    searchColumns: ['F_tname', 'F_fami', 'F_parno', 'Pmeli', 'Ptele'],
    orderBy: 'F_parno DESC'
  }
);